import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { ReportMetaClickRequest } from "../contracts/ReportMetaClickRequest";
import { ReportMetaClickResponse } from "../contracts/ReportMetaClickResponse";
import { RecordSignUpArrivalRequest } from "../contracts/RecordSignUpArrivalRequest";

/**
 * Reports the fresh account's trial start to Meta, matched by the stashed ad
 * click id. Best-effort — a non-reportable click comes back as reported: false.
 */
export const reportMetaClick = createAsyncThunk<
  ReportMetaClickResponse,
  ReportMetaClickRequest,
  { rejectValue: ApiErrorResponse }
>("attribution/reportMetaClick", async (request, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<ReportMetaClickResponse>(
      "/attribution/meta-click",
      request
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to report the ad click"));
  }
});

/**
 * Counts an anonymous arrival on the sign-up screen from a marketing-site CTA.
 * Fire-and-forget: a failure changes nothing for the visitor.
 */
export const recordSignUpArrival = createAsyncThunk<
  void,
  RecordSignUpArrivalRequest,
  { rejectValue: ApiErrorResponse }
>("attribution/recordSignUpArrival", async (request, { rejectWithValue }) => {
  try {
    await axiosInstance.post("/attribution/sign-up-arrival", request);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to record the sign-up arrival"));
  }
});
